import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const api = axios.create({ baseURL: API_URL, withCredentials: true });

// Resume point after sign-up / login. Reads the chosen tier saved by the pricing
// section, starts Stripe checkout, and redirects. Admins are sent straight into the Studio.
export default function StudioStart() {
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const tier = (localStorage.getItem('studio_subscribe_tier') || 'starter');
    try { localStorage.removeItem('studio_subscribe_tier'); } catch (_e) { /* noop */ }
    (async () => {
      try {
        const me = await api.get('/api/auth/me').then((r) => r.data).catch(() => null);
        if (me && (me.role === 'admin' || me.role === 'super_admin')) {
          navigate('/admin/social-studio', { replace: true });
          return;
        }
        const r = await api.post('/api/social-studio/subscribe/checkout', { tier, origin_url: window.location.origin });
        if (r.data?.url) { window.location.href = r.data.url; return; }
        toast.error('Could not start checkout. Please try again.');
        navigate('/studio', { replace: true });
      } catch (e) {
        const d = e.response?.data?.detail;
        toast.error(typeof d === 'string' ? d : 'Could not start checkout.');
        navigate('/studio', { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#0A0F1C] text-white" data-testid="studio-start">
      <Loader2 className="animate-spin text-[#A78BFA] mb-4" size={32} />
      <p className="text-sm text-[#CBD5E1]">Starting your secure checkout…</p>
    </div>
  );
}
